import { create } from 'zustand';

export type Section = 'jour' | 'planning' | 'eleves' | 'equipe' | 'messages';

interface BilanTarget {
  candidateId: string;
  candidateName: string;
  lessonId?: string;
}

interface UiState {
  section: Section;
  setSection: (s: Section) => void;

  bilanTarget: BilanTarget | null;
  openBilan: (target: BilanTarget) => void;
  closeBilan: () => void;

  livretStudentId: string | null;
  openLivret: (id: string) => void;
  closeLivret: () => void;

  evalStudentId: string | null;
  openEvaluation: (id: string) => void;
  closeEvaluation: () => void;

  lessonsStudent: { id: string; name: string } | null;
  openLessons: (id: string, name: string) => void;
  closeLessons: () => void;
}

export const useUiStore = create<UiState>((set) => ({
  section: 'jour',
  setSection: (section) => set({ section }),

  bilanTarget: null,
  openBilan: (bilanTarget) => set({ bilanTarget }),
  closeBilan: () => set({ bilanTarget: null }),

  livretStudentId: null,
  openLivret: (livretStudentId) => set({ livretStudentId }),
  closeLivret: () => set({ livretStudentId: null }),

  evalStudentId: null,
  openEvaluation: (evalStudentId) => set({ evalStudentId }),
  closeEvaluation: () => set({ evalStudentId: null }),

  lessonsStudent: null,
  openLessons: (id, name) => set({ lessonsStudent: { id, name } }),
  closeLessons: () => set({ lessonsStudent: null }),
}));
